import { Component } from '@angular/core';

@Component({
    selector: 'app-amazon-ads',
    template: '',
    standalone: true
})
export class AmazonAdsComponent {}
